<script lang="ts">
	//Hooks
	import { createEventDispatcher, getContext, tick } from 'svelte';
	// Design system components
	import { Icon } from '@Shelly/shelly-design-system';
	//Types
	import type { MapContext } from '../../../types/requests/services/weather';

	const { getMap }: MapContext = getContext('map'),
		map = getMap(),
		dispatcher = createEventDispatcher();

	let marker: {
		lat: number;
		lng: number;
	};

	export const open = (anchor: { lat: number; lng: number }) => {
			marker = anchor;
		},
		close = () => {
			marker = null;
			dispatcher('close');
		};

	const initInfoWindow = (element: HTMLElement, _marker: { lat: number; lng: number }) => {
		//@ts-ignore
		const infoWindow = new mapboxgl.Popup({
			offset: 38,
			closeButton: false,
			anchor: 'bottom',
		}).setDOMContent(element);
		const fitInfoWindowToMap = () => {
			const infoWindowRect = infoWindow.getElement().getBoundingClientRect(),
				mapRect = map.getContainer().getBoundingClientRect(),
				rect = {
					x: infoWindowRect.x - mapRect.x,
					y: infoWindowRect.y - mapRect.y,
					right: infoWindowRect.right - mapRect.right,
				};
			let fitPosX = 0,
				fitPosY = 0,
				offset = 25;
			if (rect.x < offset) {
				fitPosX = rect.x - offset;
			} else if (rect.right > -offset) {
				fitPosX = rect.right + offset;
			}
			if (rect.y < offset) {
				fitPosY = rect.y - offset;
			}
			if (fitPosX || fitPosY) {
				map.panBy([fitPosX, fitPosY]);
			}
		};
		return {
			async update(marker: { lat: number; lng: number }) {
				infoWindow.removeClassName('show');
				if (marker) {
					infoWindow.setLngLat([marker.lng, marker.lat]).addTo(map);
					await tick();
					infoWindow.addClassName('show');
					fitInfoWindowToMap();
				}
			},
			destroy() {
				infoWindow.remove();
			},
		};
	};
</script>

<div class="info-window" use:initInfoWindow={marker}>
	<div class="mb-s text-right cursor-pointer" on:click={close} on:keydown>
		<Icon size="s" icon="fal fa-times" />
	</div>
	<slot />
</div>

<style>
	:global(.mapboxgl-popup) {
		transition:
			opacity 0.5s,
			visibility 0.5s;
		visibility: hidden;
		opacity: 0;
		z-index: 5;
		width: 185px;
	}

	:global(.mapboxgl-popup.show) {
		visibility: visible;
		opacity: 1;
	}

	:global(.mapboxgl-popup .mapboxgl-popup-content) {
		position: relative;
		padding: 16px;
		background: var(--color-3);
		border-radius: var(--radius-small);
	}

	:global(.mapboxgl-popup.mapboxgl-popup-anchor-bottom .mapboxgl-popup-tip) {
		border-top-color: var(--color-3);
		margin-top: -1px;
		filter: drop-shadow(1px 1px 3px 0 rgb(0, 0, 0, 0.33));
	}
</style>
